export const isPlausibleGradYear = (digits: string): boolean => {
    if (!digits || digits.length !== 4) {
        return false;
    }
    const year = Number(digits);
    return year >= 1000 && year <= 3000;
};

export const GRAD_YEAR_REQUIRED_MSG = 'Graduation year required.';
export const GRAD_YEAR_INVALID_MSG = 'Please enter a valid graduation year.';

/** Returns an ATC error message, or '' if graduation year is OK to submit. */
export const getGradYearAtcError = (showGradYear: boolean, input: string, storedYear: string, required: boolean): string => {
    if (!showGradYear) {
        return '';
    }
    if (input && !isPlausibleGradYear(input)) {
        return GRAD_YEAR_INVALID_MSG;
    }
    if (required && !isPlausibleGradYear(storedYear || '')) {
        return GRAD_YEAR_REQUIRED_MSG;
    }
    return '';
};
